import { gql } from './gql'

/**
 * The shopper's most recent order, as one field.
 *
 * `getOrders` can already return it — page one, first row — but only by
 * fetching a whole page of history, filtering nothing, and trusting that the
 * server's default sort is newest-first. `lastOrder` is the server answering
 * the question directly, so "your last order" is its answer rather than our
 * inference from a list.
 *
 * Session-scoped like the rest of the order fields: the customer comes from
 * `sessionUid` and is never named by the client.
 *
 * Narrower than `GET_ORDER` on purpose. Everything this feeds — a date to say
 * out loud and a `sku -> quantity` map to put back in a cart — needs the id,
 * the date and the lines. Prices, status, totals and checkout rules belong to
 * the screen that renders an order, not to the one that repeats it, and
 * selecting them here would re-price the whole order to draw one sentence.
 *
 * Both line shapes are selected for the same reason `GET_ORDER` selects both:
 * a storefront whose cart is grouped carries `groups[].items` and an empty
 * `items`, and reading only `items` would find an order with no products.
 *
 * `skipAddon` is deliberately not declared. It exists on the field, nothing
 * here has a reason to send it, and a variable no call site sets is a knob
 * that only ever gets turned by accident.
 */
export const GET_LAST_ORDER = gql`
  query LastOrder($storefrontName: String!, $sessionUid: ID!) {
    lastOrder(storefrontName: $storefrontName, sessionUid: $sessionUid) {
      id
      createdAt
      items {
        sku
        quantity
      }
      groups {
        items {
          sku
          quantity
        }
      }
    }
  }
`
